import { render, staticRenderFns } from "./IconUpArrow.vue?vue&type=template&id=6176a580&scoped=true"
import script from "./IconUpArrow.vue?vue&type=script&lang=js"
export * from "./IconUpArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176a580",
  null
  
)

export default component.exports